import { render } from "./UpsellList.vue?vue&type=template&id=fc7e0bc0"
import script from "./UpsellList.vue?vue&type=script&lang=js"
export * from "./UpsellList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__